import { getEnv } from './app/utils/configUtils';
import CountryConfig from './CountryConfig';
import FeatureFlags from './FeatureFlags';

export const BACKEND_URL = getEnv('REACT_APP_BACKEND_IP_ADDRESS');
export const FRONTEND_URL = getEnv('REACT_APP_BASE_URL');
export const COUNTRY_CODE = getEnv('REACT_APP_COUNTRY');

export const CURRENCY = CountryConfig[COUNTRY_CODE]?.currency;
export const COUNTRY = CountryConfig[COUNTRY_CODE]?.country;
export const DEFAULT_TIMEZONE = CountryConfig[COUNTRY_CODE].defaultTimezone;
export const FEATURE_FLAGS = FeatureFlags[COUNTRY_CODE];
export const AVAILABLE_COUNTRIES = FeatureFlags[COUNTRY_CODE].availableCountries;
export const ENABLED_LGBTQ = COUNTRY_CODE !== 'MY';
// export const WHATSAPP_ALLOWED = ['MY', 'PH'].includes(COUNTRY_CODE);
export const LIFF_ID = getEnv('REACT_APP_LIFF_ID');
export const NODE_ENV = getEnv('NODE_ENV');
export const ENABLE_SEMANTIC_SEARCH = getEnv('ENABLE_SEMANTIC_SEARCH') === 'true';

export const LINE_CHANNEL_ID = getEnv('REACT_APP_LINE_CHANNEL_ID');

let DEFAULT_LANG = 'en';
if (COUNTRY_CODE === 'TH') {
  DEFAULT_LANG = 'th';
}

if (COUNTRY_CODE === 'TW') {
  DEFAULT_LANG = 'zh-TW';
}

export const DEFAULT_LANGUAGE = DEFAULT_LANG;
